import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import store from '../store';
import ReportingView from '../views/ReportingView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/home',
    name: 'Home',
    component: ReportingView,
    beforeEnter: (to, from, next) => {
      if (store.getters.checkAuth) {
        next();
      } else {
        next(false);
      }
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
